// Hand-maintained talks content.
// episodes: newest first. videoId is the YouTube video id, title is the episode title.
//   The first entry is embedded as the player and the next two render as cards below it;
//   older entries stay here but are only reachable through the YouTube playlist link.
//   Adding a future episode = one new entry at the top of the list.
// upcomingTalks: title, date (ISO YYYY-MM-DD), venue, url — rendered in this order.

export type Episode = {
    videoId: string;
    title: string;
};

export type UpcomingTalk = {
    title: string;
    date: string;
    venue: string;
    url: string;
};

export const episodes: Episode[] = [
    {
        videoId: 'ggnaxm8PWIs',
        title: 'DevUP Talks #08 – AI Agents Are the New Users: Identity, Access and Security',
    },
    {
        videoId: '9O8Eafv87L0',
        title: 'DevUP Talks #07 – From BizTalk to AI: The Tools Change, Integration Doesn’t',
    },
    {
        videoId: 'GE69gr5u59U',
        title: 'DevUP Talks #06 - The AI Wanted to Delete the Firewall, with Simon Wåhlin',
    },
    {
        videoId: 'GhSlwiGYzd8',
        title: 'DevUP Talks #05 – Logic Apps Tips & Tricks with Sandro Pereira',
    },
    {
        videoId: 'u_3Un5JThkU',
        title: 'DevUP Talks #04 – What Massimo Learned Using AI in Development',
    },
    {
        videoId: 'CrT6gygmTYw',
        title: 'DevUP Talks #03 - Discussions with Rik Hepworth',
    },
    {
        videoId: 'r639twnP3GA',
        title: 'DevUP Talks #02 - 2026 Q1 Reflections with Ahmed Bayoumy, Sebastian Meyer and Andrew Wilson',
    },
    {
        videoId: 'wQm1W-4we0M',
        title: 'DevUP Talks #01 - 2026 Q1 trends with Kent Weare',
    },
];

export const upcomingTalks: UpcomingTalk[] = [];
